export default "__VITE_ASSET__a87ea935__"